import DesignTokens from '@tableau/design-tokens';
import { cssRule } from 'typestyle';

import { applyColor }from '~src/style/ColorService';

cssRule('.root', {
    backgroundColor: applyColor(DesignTokens.color.elevation.surface.default.default, '#fff'),
    fontSize: '12px',
    height: '100%',
    position: 'relative',
});

cssRule('.geocodingBoldText', {
    fontWeight: 'bold',
    marginBottom: '3px',
});

cssRule('.geocodingLargeText', {
    fontSize: '18px',
});

cssRule('.geocodingFieldIcon', {
    marginRight: '3px',
});

cssRule('.geocodingFooterButtonContainer', {
    display: 'flex',
    justifyContent: 'flex-end',
    marginTop: '18px',
});

cssRule('.geocodingRecordsDatagrid', {
    marginTop: '12px',
    height: '120px',
    border: '1px solid ' + applyColor(DesignTokens.color.elevation.border.default.subtle, '#d4d4d4'),
    flexDirection: 'column',
});

cssRule('.newGeocodeButton', {
    marginTop: '12px',
});

cssRule('.geocodingConfgDialogContainer', {
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
});

cssRule('.geocodingConfigDialogMainContent', {
    display: 'flex',
    flexGrow: 2,
});

cssRule('.geocodingConfigDialogContent', {
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden',
    width: '100%',
});

cssRule('.geocodingConfigDialogColList', {
    display: 'flex',
    flexDirection: 'column',
    padding: '15px',
    minWidth: '150px',
    border: '1px solid ' + applyColor(DesignTokens.color.elevation.border.default.subtle, '#d4d4d4'),
});

cssRule('.geocodingConfigInputFieldsArea', {
    padding: '0 15px',
});

cssRule('.geocodingConfigInputFieldsArea > div', {
    width: '100%',
});

cssRule('.geocodingConfigTabs > [role="tablist"]', {
    borderBottom: '2px solid ' + applyColor(DesignTokens.color.component.border.neutral.default.active, '#ebebeb'),
});

cssRule('.geocodeTabLabelIndent', {
    marginLeft: '26px',
});

cssRule('.geocodingChipLabel', {
    marginBottom: '3px',
});

cssRule('.geocodingInfoTextBlock', {
    marginBottom: '12px',
    marginTop: '12px',
});

cssRule('.geocodingInfoTextBlock > div', {
    marginBottom: '3px',
});

cssRule('.geocodingEditorButton', {
    display: 'flex',
    justifyContent: 'flex-end',
});

cssRule('.geocodingDsEditorBtn', {
    display: 'block',
    fontWeight: 'bold',
    marginLeft: 'auto',
});

cssRule('.geocodingTokenLimitInfo', {
    marginBottom: '12px',
});

cssRule('.geocodingEstimateTabContent', {
    marginTop: '12px',
});

cssRule('.geocodingColumnChip', {
    paddingLeft: '5px',
    marginRight: '5px',
    marginBottom: '5px',
});

cssRule('.geocodingConfigRecordsDatagrid', {
    marginTop: '12px',
    marginBottom: '12px',
    height: '120px',
});

